"use client";

import React, { useEffect, useRef, useState } from "react";
import styles from "./SliderWrapper.module.scss";

export default function SliderWrapper({
  children,
  itemWidth = 280,
  gap = 12,
  className = "",
}) {
  const containerReference = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  // Set total number of cards
  useEffect(() => {
    if (containerReference.current) {
      setTotalItems(containerReference.current.children.length);
    }
  }, [children]);

  // Track scroll position to update active dot
  const handleScroll = () => {
    if (!containerReference.current) return;
    const { scrollLeft } = containerReference.current;
    const currentIndex = Math.round(scrollLeft / (itemWidth + gap));
    setActiveIndex(currentIndex);
  };

  // Scroll to specific item on dot click
  const scrollToIndex = (index) => {
    if (!containerReference.current) return;
    containerReference.current.scrollTo({
      left: index * (itemWidth + gap),
      behavior: "smooth",
    });
  };

  return (
    <div className={`${styles.sliderWrapper} ${className}`}>
      {/* Scrollable Cards */}
      <div
        ref={containerReference}
        onScroll={handleScroll}
        className={styles.sliderContainer}
        style={{ gap: `${gap}px` }}
      >
        {React.Children.map(children, (child, index) => (
          <div
            key={index}
            className={styles.sliderItem}
            style={{ width: `${itemWidth}px` }}
          >
            {child}
          </div>
        ))}
      </div>

      {/* Dots (visible on mobile only) */}
      <div className={styles.dotsContainer}>
        {Array.from({ length: totalItems }).map((_, index) => (
          <button
            key={index}
            onClick={() => scrollToIndex(index)}
            className={`${styles.dot} ${index === activeIndex ? styles.dotActive : ""}`}
          />
        ))}
      </div>
    </div>
  );
}
